<div class="card customed-card" style="border: none">
    <div class="card-header" style="border: none">
        <div class="customed-container ">
            <ul class="customed-progressbar d-flex justify-content-center">
                <li [ngClass]="gestao ? 'active' : ''">Gestão ABRAPA</li>
                <li [ngClass]="andamento ? 'active' : ''">Andamento da Certificação</li>
            </ul>
        </div>
    </div>
</div>